
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("c3ssB", function(module, exports) {

$parcel$export(module.exports, "default", () => $48587ce7e677e00e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eEnT4 = parcelRequire("eEnT4");

var $1PVpv = parcelRequire("1PVpv");

var $VSDnB = parcelRequire("VSDnB");

var $l4haf = parcelRequire("l4haf");
var $48587ce7e677e00e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)(function Status(props) {
    const { text: text, color: color, localId: localId } = props;
    const inlineAnnotationProps = (0, $l4haf.useInlineAnnotationProps)(props);
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...inlineAnnotationProps,
        role: (0, $VSDnB.fg)('editor_a11y_status_renderer_description') ? 'emphasis' : undefined,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.FabricElementsAnalyticsContext), {
            data: {
                userContext: 'document'
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eEnT4.Status), {
                text: text,
                color: color,
                localId: localId,
                role: (0, $VSDnB.fg)('editor_a11y_status_renderer_description') ? undefined : 'presentation',
                isBold: (0, $VSDnB.fg)('platform-component-visual-refresh')
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: {
            userContext: 'document'
        },
        children: (0, $VSDnB.fg)('editor_a11y_status_renderer_description') ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            role: "emphasis",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eEnT4.Status), {
                text: text,
                color: color,
                localId: localId,
                isBold: (0, $VSDnB.fg)('platform-component-visual-refresh')
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eEnT4.Status), {
            text: text,
            color: color,
            localId: localId,
            role: "presentation",
            isBold: (0, $VSDnB.fg)('platform-component-visual-refresh')
        })
    });
});

});
parcelRegister("eEnT4", function(module, exports) {

$parcel$export(module.exports, "Status", () => $16832393d4e455fa$export$96e9906d6d93a972);
/* Status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eHWoK = parcelRequire("eHWoK");

var $cb25w = parcelRequire("cb25w");

var $bAjc1 = parcelRequire("bAjc1");

const $16832393d4e455fa$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
const $16832393d4e455fa$var$DEFAULT_APPEARANCE = 'default';
const $16832393d4e455fa$var$MAX_WIDTH = 200;
/**
 * This is to account for a bug in android chromium and should be removed
 * when the editor fixes its focus handling with respect to Status.
 *
 * See DSP-7701 for additional context.
 */ const $16832393d4e455fa$var$inlineBlockStyles = null;
// eg. Version/4.0 Chrome/95.0.4638.50
const $16832393d4e455fa$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $16832393d4e455fa$var$StatusInternal extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'StatusInternal';
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $16832393d4e455fa$var$colorToLozengeAppearanceMap[color] || $16832393d4e455fa$var$DEFAULT_APPEARANCE;
        // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bwpsq.default)([
                $16832393d4e455fa$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eHWoK.default), {
                appearance: appearance,
                maxWidth: $16832393d4e455fa$var$MAX_WIDTH,
                isBold: isBold,
                children: text
            })
        });
    }
    constructor(...args){
        super(...args), this.hoverStartTime = 0, this.handleMouseEnter = (_e)=>{
            this.hoverStartTime = Date.now();
        }, this.handleMouseLeave = (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $0bb968abb24f3c41$export$7452d7062a4d0634) && onHover) onHover();
            this.hoverStartTime = 0;
        };
    }
}
const $16832393d4e455fa$export$96e9906d6d93a972 = (0, $cb25w.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $bAjc1.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $bAjc1.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($16832393d4e455fa$var$StatusInternal);

});
parcelRegister("bAjc1", function(module, exports) {

$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $5096d806c4ff6ab5$export$aa98853957f9f5aa);
const $5096d806c4ff6ab5$export$d821aa4c8afb384e = 'fabric-elements';
const $5096d806c4ff6ab5$var$packageName = "platform-pkg";
const $5096d806c4ff6ab5$var$packageVersion = "0.0.0-use.local";
const $5096d806c4ff6ab5$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $5096d806c4ff6ab5$var$packageName;
        statusPayload.attributes.packageVersion = $5096d806c4ff6ab5$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($5096d806c4ff6ab5$export$d821aa4c8afb384e);
        return event;
    };

});

const $0bb968abb24f3c41$export$7452d7062a4d0634 = 1000;


parcelRegister("l4haf", function(module, exports) {

$parcel$export(module.exports, "useInlineAnnotationProps", () => $d0388e6a4f35db6c$export$11564cda945bb3c9);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $iYAgE = parcelRequire("iYAgE");
function $d0388e6a4f35db6c$export$11564cda945bb3c9(props) {
    const draftPosition = (0, $5uXOq.useContext)((0, $iYAgE.AnnotationsDraftContext));
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}

});



//# sourceMappingURL=status.a0f8a56b.js.map
